import Raven from 'raven-js';
import { onFetchContentSchemaSuccess, onFetchContentSchemaFailed
// @ts-expect-error not typed
} from 'ContentEditorUI/redux/actions/appActions';
// @ts-expect-error not typed
import { getContentTypeName } from 'ContentEditorUI/redux/selectors/contentTypeSelector';
import { standardFetchCustomModules, fetchModuleSchemasFailed, fetchModuleSchemasSucceeded
// @ts-expect-error not typed
} from 'ContentEditorUI/redux/actions/moduleSchemaActions';
import { getContentAssistantSettings } from 'ContentEditorUI/redux/actions/contentAssistantActions';
import { fetchContentSchema, fetchGlobalModules } from '../api/editorClients';
import { fetchRowAndSchemas } from 'structured-content-lib/redux/actions/instanceEditActions';
import { selectActiveHubDbRowId } from 'structured-content-lib/redux/selectors/instanceEditSelectors';
import { fetchArticle } from '../../articles/api/articlesApi';
export const initialRequestActions = () => (dispatch, getState) => {
  const contentPromise = fetchContentSchema().then(result => {
    const tableName = result.content.dynamicPageDataSourceId;
    const state = getState();
    const articleId = selectActiveHubDbRowId(state);
    dispatch(fetchRowAndSchemas(tableName, fetchArticle.bind(null, articleId)));
    return dispatch(onFetchContentSchemaSuccess({
      result
    }));
  }, result => dispatch(onFetchContentSchemaFailed({
    result
  })));
  const globalPromise = fetchGlobalModules().then(response => ({
    response
  }), error => ({
    error
  }));

  // Note, getContentAssistantSettings already has rejection default fallback logic, so marking
  // this promise as void to appease the no-floating-promises rule
  void dispatch(getContentAssistantSettings());
  const customModulePromise = dispatch(standardFetchCustomModules());
  return Promise.all([globalPromise, customModulePromise, contentPromise]).then(requests => {
    const [globalModules = {}, customModules = {}] = requests;
    const categoryName = getContentTypeName(getState());

    // Need to check for errors again, because we already dispatch the failure action for each
    // of the sub-requests, which turns it into a resolved promise again
    for (const request of requests) {
      if (!request) {
        Raven.captureMessage('request is not defined ', {
          extra: {
            requests
          }
        });
      }
      if (request && request.error) {
        return dispatch(fetchModuleSchemasFailed(request));
      }
    }
    return dispatch(fetchModuleSchemasSucceeded({
      categoryName,
      globalModules: globalModules.response,
      customModules: customModules.response
    }, {
      fromSuperStoreCache: customModules.fromSuperStoreCache
    }));
  });
};